// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__2TrZT","switchContainer":"Switch_switchContainer__3qcML"};